import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ForecastFieldsFragment = { __typename?: 'ForecastStateData', forecastId: string, name: string, description: string, customerId: string, programIds: Array<string>, startDate: Types.TDateISO, endDate: Types.TDateISO, level: Types.ForecastLevel, weeklyMetric: Types.ForecastWeeklyMetric, scenarioSlot: Types.ForecastScenarioSlot, status: Types.ForecastStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type CreateForecastMutationVariables = Types.Exact<{
  input: Types.CreateForecastInput;
}>;


export type CreateForecastMutation = { __typename?: 'Mutation', createForecast: { __typename?: 'ForecastPayload', forecast?: { __typename?: 'ForecastStateData', forecastId: string, name: string, description: string, customerId: string, programIds: Array<string>, startDate: Types.TDateISO, endDate: Types.TDateISO, level: Types.ForecastLevel, weeklyMetric: Types.ForecastWeeklyMetric, scenarioSlot: Types.ForecastScenarioSlot, status: Types.ForecastStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateForecastMutationVariables = Types.Exact<{
  input: Types.UpdateForecastInput;
}>;


export type UpdateForecastMutation = { __typename?: 'Mutation', updateForecast: { __typename?: 'ForecastPayload', forecast?: { __typename?: 'ForecastStateData', forecastId: string, name: string, description: string, customerId: string, programIds: Array<string>, startDate: Types.TDateISO, endDate: Types.TDateISO, level: Types.ForecastLevel, weeklyMetric: Types.ForecastWeeklyMetric, scenarioSlot: Types.ForecastScenarioSlot, status: Types.ForecastStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteForecastMutationVariables = Types.Exact<{
  input: Types.DeleteForecastInput;
}>;


export type DeleteForecastMutation = { __typename?: 'Mutation', deleteForecast: { __typename?: 'ForecastPayload', forecast?: { __typename?: 'ForecastStateData', forecastId: string, status: Types.ForecastStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type MergeForecastSettingsMutationVariables = Types.Exact<{
  input: Types.MergeForecastSettingsInput;
}>;


export type MergeForecastSettingsMutation = { __typename?: 'Mutation', mergeForecastSettings: { __typename?: 'ForecastSettingsPayload', state?: { __typename?: 'ForecastSettingsStateData', tenantId: string, compAim: number, compMin: number, compMax: number, excludedHistoryYears: Array<number>, maxYearOffset: number, roundingBias: number, shipShift: boolean, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const ForecastFieldsFragmentDoc = new TypedDocumentString(`
    fragment ForecastFields on ForecastStateData {
  forecastId
  name
  description
  customerId
  programIds
  startDate
  endDate
  level
  weeklyMetric
  scenarioSlot
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ForecastFields"});
export const CreateForecastDocument = new TypedDocumentString(`
    mutation CreateForecast($input: CreateForecastInput!) {
  createForecast(input: $input) {
    forecast {
      ...ForecastFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ForecastFields on ForecastStateData {
  forecastId
  name
  description
  customerId
  programIds
  startDate
  endDate
  level
  weeklyMetric
  scenarioSlot
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const UpdateForecastDocument = new TypedDocumentString(`
    mutation UpdateForecast($input: UpdateForecastInput!) {
  updateForecast(input: $input) {
    forecast {
      ...ForecastFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ForecastFields on ForecastStateData {
  forecastId
  name
  description
  customerId
  programIds
  startDate
  endDate
  level
  weeklyMetric
  scenarioSlot
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeleteForecastDocument = new TypedDocumentString(`
    mutation DeleteForecast($input: DeleteForecastInput!) {
  deleteForecast(input: $input) {
    forecast {
      forecastId
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
export const MergeForecastSettingsDocument = new TypedDocumentString(`
    mutation MergeForecastSettings($input: MergeForecastSettingsInput!) {
  mergeForecastSettings(input: $input) {
    state {
      ...ForecastSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ForecastSettingsFields on ForecastSettingsStateData {
  tenantId
  compAim
  compMin
  compMax
  excludedHistoryYears
  maxYearOffset
  roundingBias
  shipShift
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateForecast: build.mutation<CreateForecastMutation, CreateForecastMutationVariables>({
      query: (variables) => ({ document: CreateForecastDocument, variables })
    }),
    UpdateForecast: build.mutation<UpdateForecastMutation, UpdateForecastMutationVariables>({
      query: (variables) => ({ document: UpdateForecastDocument, variables })
    }),
    DeleteForecast: build.mutation<DeleteForecastMutation, DeleteForecastMutationVariables>({
      query: (variables) => ({ document: DeleteForecastDocument, variables })
    }),
    MergeForecastSettings: build.mutation<MergeForecastSettingsMutation, MergeForecastSettingsMutationVariables>({
      query: (variables) => ({ document: MergeForecastSettingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateForecastMutation, useUpdateForecastMutation, useDeleteForecastMutation, useMergeForecastSettingsMutation } = injectedRtkApi;
